import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  errorContainer: {
    padding: '2rem',
    textAlign: 'center',
  },
  tabsContainer: {
    borderBottom: 'none',
    backgroundColor: 'transparent',
    gap: '4px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabIndicator: {
    display: 'none',
  },
  tabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },
  tab: {
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 600,
    minHeight: '40px',
    padding: '10px 20px',
    margin: '0',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    borderBottom: '3px solid transparent',
    justifyContent: 'flex-start',
    marginRight: '12px',
    '&:hover': {
      borderBottom: '3px solid #cbd5e1',
    },
  },
  tabActive: {
    fontWeight: 600,
    color: '#254B86',
    borderBottom: '3px solid rgba(55,81,255,1)',
    '&:hover': {
      borderBottom: '3px solid rgba(55,81,255,1)',
    },
  },
  tabInactive: {
    fontWeight: 600,
    color: '#1a1a1a',
    backgroundColor: 'transparent',
    opacity: 0.7,
  },
  tabDisabled: {
    color: '#cbd5e1',
    opacity: 0.5,
    cursor: 'not-allowed',
    '&:hover': {
      backgroundColor: 'transparent',
      borderLeft: '3px solid transparent',
    },
  },
  subtitleError: {
    color: '#f44336',
  },
  statusConnected: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '2px 10px',
    borderRadius: '12px',
    backgroundColor: '#ecfdf5',
    color: '#065f46',
    fontSize: '13px',
    fontWeight: 500,
    border: '1px solid #a7f3d0',
  },
  statusDot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: '#10b981',
    flexShrink: 0,
  },
  statusNotConfigured: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '2px 10px',
    borderRadius: '12px',
    backgroundColor: '#fef2f2',
    color: '#991b1b',
    fontSize: '13px',
    fontWeight: 500,
    border: '1px solid #fecaca',
  },
  statusDotError: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: '#ef4444',
    flexShrink: 0,
  },
  statusHint: {
    color: '#6b7280',
    fontWeight: 400,
    marginLeft: '4px',
  },
});

export default useStyles;
